import { useQuery } from '@tanstack/react-query'

// SCD-600: see mutateLogoPlate — routeName picks the host-appropriate registration.
export const queryLogoPlateInspect = ({ src = null, routeName = 'studio.v1.api.logo_plate.store', ...params }) => {

    const query = useQuery({
        queryKey: ['logo-plate-inspect', routeName, src, params],
        enabled: !!src,
        queryFn: async () => {
            const { data } = await axios.post(route(routeName), { logo_url: src, inspect_only: true, ...params });
            return data;
        },
    });

    return query;
}
